module.exports = __webpack_public_path__ + "img/drive-dil-2.24a6cc63.svg";